
import axios from 'axios';
import { APIOverrides } from '../../ApiOverrides';
import type { DiscordPlayerProps } from '../../types';

//let SOCIAL_SVC_API = '';
//let EVENT_SVC_API = '';
//let MK_SVC_API = '';
let AUTH_SVC_API = '';
//let TP_SVC_API = ''

export const DiscordPlayerApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        //SOCIAL_SVC_API = endpoints['SOCIAL_SVC_API'] as string;
        //EVENT_SVC_API = endpoints['EVENT_SVC_API'] as string;
        //MK_SVC_API = endpoints['MK_SVC_API'] as string;
        AUTH_SVC_API = endpoints['AUTH_SVC_API'] as string;
        //TP_SVC_API = endpoints['TP_SVC_API'] as string;
    },
    getMyDiscordConnection: async():Promise<DiscordPlayerProps | undefined> => {
        try {
            const resp = await axios.get(`${AUTH_SVC_API}/v1/players/discord/me`);
            return resp.data.discord_player
        } catch (e) {
            console.log(e);
            return undefined
        }
    },
    startConnnection: async():Promise<DiscordPlayerProps | undefined> => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/discord/connect`);
            return resp.data.discord_player
        } catch (e) {
            console.log(e)
            return undefined
            
        }
    },
    confirmConnection: async():Promise<DiscordPlayerProps | undefined> => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/discord/confirm`);
            return resp.data.discord_player
        } catch (e) {
            console.log(e);
            return undefined
        }
    },
    disconnect: async():Promise<DiscordPlayerProps | undefined> => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/discord/disconnect`);
            return resp.data.discord_player
        } catch (e) {
            return undefined
        }
    }
}